export const BASE_URL = 'https://prod.porsche.huskyjam.com'
// export const BASE_URL = 'https://master.porsche.huskyjam.com'


// WEBPACK FOOTER //
// ./src/config.js